import React from "react"
import { Image, Text, Pressable, View } from "react-native"

import { getImagePath } from "../../services/CommonUtils";
import { extendProductCategoryData } from "../../services/ExtendedDataUtils"

import TextStyle from "../../../TextStyle"
import AppStyles from "../../../AppStyles"
import AppTheme from "../../../AppTheme";

export const ProductCategoryCardView = (props) => {
    let index = props.index
    let category = extendProductCategoryData(props.category)
    let catDiscount = ''
    if (category.md) catDiscount = 'Upto ' + category.md + '% OFF'
    let numColumns = props?.numColumns
    let iconSize = props.iconSize

    function getRightMargin(index) {
        if (numColumns)
            return (index + 1) % numColumns == 0 ? 0 : 16
        else return 12
    }

    return <Pressable onPress={() => props.action(category)}
        style={[AppStyles.mt24, AppStyles.alignCenter,
        { marginRight: getRightMargin(index), alignSelf: "flex-start", marginTop: index == 0 || index == 1 || index == 2 ? 12 : 24 }]}
        onLongPress={() => { console.log('### long press') }}>

        <View>
            {catDiscount ? <View style={[{
                position: "absolute", bottom: 4, left: 5.2, paddingVertical: 0.5, width: iconSize - 10,
                backgroundColor: AppTheme.color.green.primary, zIndex: 6, borderBottomLeftRadius: 12, borderBottomRightRadius: 12
            }]}><Text style={[TextStyle.text10, TextStyle.colorWhite, TextStyle.alignCenter]} numberOfLines={1}>
                    {catDiscount}</Text>
            </View> : null}

            <Image style={{ width: iconSize, height: iconSize }}
                source={getImagePath(category.icon)} />
        </View>


        <Text style={[TextStyle.text14b, TextStyle.alignCenter, TextStyle.flexWrap, AppStyles.mt8, { maxWidth: iconSize }]}>
            {category.name}</Text>

    </Pressable>
}